import { I18n } from 'utils/i18n';

const requiredError = field => () =>
  I18n.t('ChatFlowSettings.errors.Field is required', {
    field: I18n.t(`ChatFlowSettings.fields.${field}`),
  });

export default requiredError;
